import { render, staticRenderFns } from "./InfoSubmitMobileModal.vue?vue&type=template&id=20365c82&scoped=true"
import script from "./InfoSubmitMobileModal.vue?vue&type=script&lang=js"
export * from "./InfoSubmitMobileModal.vue?vue&type=script&lang=js"
import style0 from "./InfoSubmitMobileModal.vue?vue&type=style&index=0&id=20365c82&prod&lang=scss&scoped=true"
import style1 from "./InfoSubmitMobileModal.vue?vue&type=style&index=1&id=20365c82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20365c82",
  null
  
)

export default component.exports